/**
 * The dashboard's Learn card (board learn-r1 A, answer 4): the recipe to read next and two more, picked from what the
 * dashboard already knows (pickRecipes), and the way into the manual. Quiet when the manual can't be reached.
 */
import { pickRecipes, RecipeList, RECIPES_PATH, type LearnState } from '../../domain/learn'
import type { Api } from '../../infra/api'
import { Inline, Link, Skeleton, Stack, Text } from '../../ui'
import { useLoad } from '../useLoad'
import { RecipeLine } from './Learn'

export function LearnCard({ api, state }: { api: Api; state: LearnState }) {
  const list = useLoad(() => api.get(RECIPES_PATH, RecipeList), [api])
  const picks = pickRecipes(list.data?.recipes ?? [], state)
  return (
    <Stack gap="md">
      {list.data ? (
        picks.length ? (
          <Stack gap="md">
            <Text tone="muted" size="sm">
              Next for you:
            </Text>
            {picks.map((r) => (
              <RecipeLine key={r.slug} recipe={r} />
            ))}
          </Stack>
        ) : (
          <Text tone="muted">Every recipe for building with your agent, from your first request to your first routine.</Text>
        )
      ) : list.error ? (
        <Text tone="muted">Short recipes for building with your agent. The list didn't load just now.</Text>
      ) : (
        <Stack gap="sm" label="Loading">
          <Skeleton />
          <Skeleton />
        </Stack>
      )}
      <Inline justify="between">
        <Link to="/learn">Open the manual</Link>
        {list.data && (
          <Text tone="faint" size="sm">
            {list.data.recipes.length} recipes
          </Text>
        )}
      </Inline>
    </Stack>
  )
}
